import React from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import {makeStyles} from "@material-ui/core/styles";
import clsx from "clsx";

const useStyles = makeStyles(theme => ({
  cell: {
    height: "100%",
    textAlign: "center",
    border: "none"
  },
  title: {
    marginBottom: 0,
    textAlign: "center",
    fontWeight: "400 !important"
  }
}));

const Empty = ({emptyText, emptyComponent}) => {
  const classes = useStyles();
  return (
    <div className="d-flex h-100">
      {emptyComponent ? (
        emptyComponent
      ) : (
        <Table className="h-100">
          <TableBody className="h-100">
            <TableRow className="h-100">
              <TableCell className={classes.cell}>
                <h2 className={clsx("m-text-muted c-text-s3", classes.title)}>
                  {emptyText}
                </h2>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      )}
    </div>
  );
};

export {Empty};
